module.exports = __webpack_public_path__ + "static/media/9DESA16.cac3da23.jpg";